import React from 'react';
import { DatePicker } from 'antd';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import Status from '../status.jsx';
import style from './style.module.scss';
import moment from 'moment';

const DateFieldInput = ({ name, label, placeholder, isRequired = false, ...restProps }) => {
  return (
    <Field name={name}>
      {({ form }) => {
        const value = form.values[name];
        const touched = form.touched[name];
        const error = form.errors[name];
        const showError = touched && error;

        return (
          <div className={style['input-wrapper']}>
            {!!isRequired && (
              <p className={style['required-check']}>
                {isRequired && <Status isFilled={!showError && !!value} />}
              </p>
            )}

            <div className={style['label-box']}>
              <p className={style.label}>{label}</p>
              <div className={style.box}>
                <DatePicker
                  id={name}
                  className={style.input}
                  placeholder={placeholder}
                  status={showError ? 'error' : ''}
                  value={value ? moment(value) : null}
                  onChange={(val) => {
                    form.setFieldValue(name, val ? moment(val) : null);
                  }}
                  onBlur={() => form.setFieldTouched(name, true)}
                  style={{ width: '100%' }}
                  {...restProps}
                />
                {showError && <p className={style.error}>{error}</p>}
              </div>
            </div>
          </div>
        );
      }}
    </Field>
  );
};

DateFieldInput.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default DateFieldInput;
